import { Model } from './models/model';
import { Controller } from './controllers/controller';
import { create } from './utils/create';
import { parseUrlParams } from './utils/url';
import { Footer } from './components/Footer/Footer';
import { Router } from './Router/Router';
import { PageMain } from './pages/PageMain/PageMain';
import { Page404 } from './pages/Page404/Page404';
import { PageDetails } from './pages/PageDetails/PageDetails';
import { Catalog } from './pages/PageCatalog/PageCatalog';
import { PageCart } from './pages/PageCart/PageCart';
import { Popup } from './components/Popup/Popup';
import { Header } from './components/Header/Header';
export class App {
    constructor(root) {
        this.BASE_STATE = {
            products: [],
            currProductID: 0,
            productsToShow: [],
            namesToShow: [],
            categoryFilters: [],
            nameFilters: [],
            sort: '',
            search: '',
            view: 'viewMain',
            cartProducts: []
        };
        this.createDefaultLayer = () => {
            this.main = create({
                tagName: 'main',
                dataAttr: [['id', 'main']],
                parent: this.root
            });
            this.footer = create({
                tagName: 'div',
                dataAttr: [['id', 'footer']],
                parent: this.root
            });
        };
        this.init = () => {
            this.createDefaultLayer();
            const model = new Model(this.BASE_STATE);
            const controller = new Controller(model);
            const router = new Router(this.main);
            if (localStorage.length !== 0) {
                controller.getCartItemsFromStorage();
            }
            // Static components
            const footer = new Footer(this.footer);
            footer.mount();
            // Dynamic components
            const header = new Header(this.main, router.route, controller);
            header.update();
            const pageMain = new PageMain(model, this.main, router.route, controller, header);
            const pageCart = new PageCart(this.main, model, controller, header);
            const pageCatalog = new Catalog(this.main, model, controller, router.route, pageCart, header);
            const page404 = new Page404(this.main, router.route, header);
            const pageDetails = new PageDetails(this.main, model, controller, router.route, header);
            const popup = new Popup(this.main, controller);
            popup.mount();
            controller.setPopup(popup);
            fetch('../assets/data/data.json')
                .then((data) => data.json())
                .then((data) => controller.setData(data.products))
                .then(() => {
                var _a, _b;
                const params = parseUrlParams();
                if ((_a = params === null || params === void 0 ? void 0 : params.categoryFilters) === null || _a === void 0 ? void 0 : _a.length) {
                    params.categoryFilters.forEach((category) => {
                        controller.addFilterByCategory(category);
                    });
                }
                if ((_b = params === null || params === void 0 ? void 0 : params.nameFilters) === null || _b === void 0 ? void 0 : _b.length) {
                    params.nameFilters.forEach((name) => {
                        controller.addFilterByName(name);
                    });
                }
                if (params === null || params === void 0 ? void 0 : params.sort) {
                    controller.addSorting(params.sort.toString());
                }
                if (params === null || params === void 0 ? void 0 : params.search) {
                    controller.addSearching(params === null || params === void 0 ? void 0 : params.search.toString());
                }
                if (params === null || params === void 0 ? void 0 : params.view) {
                    controller.changeView(params === null || params === void 0 ? void 0 : params.view.toString());
                }
            });
            const routes = {
                '404': {
                    mount: page404.mount,
                    unmount: page404.unmount
                },
                '/': {
                    mount: pageMain.mount,
                    unmount: pageMain.unmount
                },
                '/filter': {
                    mount: pageCatalog.mount,
                    unmount: pageCatalog.unmount,
                    mountedProps: {
                        mounted: () => {
                            model.fire();
                        }
                    }
                },
                '/details/:id': {
                    mount: pageDetails.mount,
                    unmount: pageDetails.unmount,
                    mountedProps: {
                        mounted: () => {
                            model.fire();
                        }
                    }
                },
                '/cart': {
                    mount: pageCart.mount,
                    unmount: pageCart.unmount,
                    mountedProps: {
                        mounted: () => {
                            model.fire();
                        }
                    }
                }
            };
            // Router
            router.initRouter(routes);
            model.fire();
        };
        this.root = root;
        this.main = null;
        this.footer = null;
    }
}
